import { FormControl } from '@angular/forms';

export class TrackedFormControl extends FormControl {
  public changed: boolean = false;
  public shouldTrack: boolean = true;
  public autoSave: boolean = false;

  constructor(formState?: any, validatorOrOpts?: any, asyncValidator?: any, shouldTrack: boolean = true) {
    super(formState, validatorOrOpts, asyncValidator);
    this.shouldTrack = shouldTrack;
    
    // Subscribe to value changes to track when the control is actually modified by user input
    this.valueChanges.subscribe(() => {
      if (this.shouldTrack && !this.pristine) {
        this.changed = true;
      }
    });
  }
  
  // Override setValue to properly track changes
  override setValue(value: any, options?: {onlySelf?: boolean; emitEvent?: boolean; emitModelToViewChange?: boolean; emitViewToModelChange?: boolean}) {
    // Only mark as changed if the value is actually different, we're tracking changes, 
    // and this is not a programmatic update (emitEvent !== false)
    if (this.shouldTrack && this.value !== value && options?.emitEvent !== false) {
      this.changed = true;
    }
    
    // Call the parent class setValue method
    return super.setValue(value, options);
  }
  
  // Override patchValue to properly track changes
  override patchValue(value: any, options?: {onlySelf?: boolean; emitEvent?: boolean; emitModelToViewChange?: boolean; emitViewToModelChange?: boolean}) {
    // Only mark as changed if the value is actually different, we're tracking changes,
    // and this is not a programmatic update (emitEvent !== false)
    if (this.shouldTrack && this.value !== value && options?.emitEvent !== false) {
      this.changed = true;
    }
    
    // Call the parent class patchValue method
    return super.patchValue(value, options);
  }
  
  // Method to reset the changed state
  public resetChanged() {
    this.changed = false;
  }
}